<template>
  <!--评价-->
  <div class="score-module">
    <ul class="star-list">
      <li class="star"
        v-for="(item, index) in stars"
        :class="item"
        :style="setStarSize()"
        @click="toggleScore(index + 1)"></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'score-module',
  props: {
    // 分数 0~5
    score: {
      default: 5
    },
    // 星星大小
    size: {
      default: 24
    }
  },
  data () {
    return {
      stars: []
    }
  },
  methods: {
    toggleScore (score) {
      this.$emit('toggleScore', score)
    },
    // 计算评分转换为星星
    getStars () {
      this.stars = []
      for (let i = 1; i <= Number(this.score); i++) {
        this.stars.push('on')
      }
      if (Number(this.score) !== Math.floor(this.score)) {
        this.stars.push('half')
      }
      for (let i = 0, len = 5 - this.stars.length; i < len; i++) {
        this.stars.push('off')
      }
    },
    // 设置评分星星大小
    setStarSize () {
      return {
        width: `${parseInt(this.size) / 200}rem`,
        height: `${parseInt(this.size) / 200}rem`
      }
    }
  },
  mounted () {
    this.getStars()
  },
  watch: {
    score () {
      this.getStars()
    }
  }
}
</script>

<style lang="less" scoped>
@image: "../../assets/images/";

.score-module {
  overflow: hidden;

  .star-list {
    .star {
      float: left;
      margin-right: 2/200rem;
      background-image: url("@{image}star-on.png");
      background-size: 100% 100%;

      &:last-child {
        margin-right: 0;
      }
      &.half {
        background-image: url("@{image}star-half.png");
      }
      &.off {
        background-image: url("@{image}star-off.png");
      }
    }
  }
}
</style>
